export default class SeeMore {

  constructor(el) {
    this.el = el;
    this.link = el.find('.js-see-more_link');
    this.text = el.find('.js-see-more_text');

    this.handleEvents();
  }

  handleEvents() {
    this.link.click(e => {
      this.text.show();
      this.link.hide();
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/see-more/see-more.js